module.exports = __webpack_public_path__ + "img/28.1f31fb85.svg";